// Product Detail Page Translations
export const productDetailTranslations = {
  en: {
    // Billing Period
    monthly: 'Monthly',
    yearly: 'Yearly',
    billedMonthly: 'Billed monthly',
    billedYearly: 'Billed yearly',

    // Offers & Badges
    limitedTimeOffer: 'Limited Time Offer',
    outOfStock: 'Out of Stock',
    inStock: 'In Stock',

    // Rating
    outOf: 'out of',

    // Section Headings
    description: 'Description',
    featuresAndBenefits: 'Features and Benefits',
    howItWorks: 'How It Works?',
    whyChooseThis: 'Why You Should Choose This Service?',
    customerReviews: 'Customer Reviews',
    paymentMethods: 'Payment Methods',
    needHelp: 'Need Help?',

    // Trust Badges
    genuineLabel: '100% Genuine',
    genuineDesc: 'All subscriptions are authentic and verified',
    secureLabel: 'Secure',
    secureDesc: 'Bank-level encryption for all transactions',
    moneyBackLabel: 'Money Back',
    moneyBackDesc: '30-day money-back guarantee',

    // Buttons & Actions
    addToCart: 'Add to Cart',
    instantDelivery: 'Instant Delivery via Email',

    // Labels
    advancedFeatures: 'Advanced Features',
    professionalTools: 'Professional tools and resources',
    unlimitedAccess: 'Unlimited access to premium content',
    dedicatedSupport: '24/7 dedicated support',
    benefits: 'Benefits',
    saveTime: 'Save time and increase productivity',
    itemsUnlocked: 'All items unlocked and ready to use',
    plansAvailable: 'Monthly or lifetime plans available',

    // Review Labels
    rating: 'Rating',
    outOfStock_msg: 'Out of Stock',
    inStock_msg: 'In Stock',

    // Contact Info
    emailLabel: 'Email',
    whatsappLabel: 'WhatsApp',
    telegramLabel: 'Telegram',

    // Quantity
    quantity: 'Quantity',
    decrease: 'Decrease',
    increase: 'Increase',

    // Price Info
    regularPrice: 'Regular Price',
    discountedPrice: 'Discounted Price',
    save: 'Save',
    discount: 'Discount',

    // Monthly/Yearly text
    monthlyPlan: 'Monthly Plan',
    yearlyPlan: 'Yearly Plan',

    // Support hours
    supportHours: '10 AM - 11 PM (PKT)',
  },

  fr: {
    // Billing Period
    monthly: 'Mensuel',
    yearly: 'Annuel',
    billedMonthly: 'Facturé mensuellement',
    billedYearly: 'Facturé annuellement',

    // Offers & Badges
    limitedTimeOffer: 'Offre à Durée Limitée',
    outOfStock: 'Rupture de Stock',
    inStock: 'En Stock',

    // Rating
    outOf: 'sur',

    // Section Headings
    description: 'Description',
    featuresAndBenefits: 'Caractéristiques et Avantages',
    howItWorks: 'Comment Ça Marche?',
    whyChooseThis: 'Pourquoi Devriez-Vous Choisir Ce Service?',
    customerReviews: 'Avis des Clients',
    paymentMethods: 'Méthodes de Paiement',
    needHelp: 'Besoin d\'Aide?',

    // Trust Badges
    genuineLabel: '100% Légitime',
    genuineDesc: 'Tous les abonnements sont authentiques et vérifiés',
    secureLabel: 'Sécurisé',
    secureDesc: 'Chiffrement de niveau bancaire pour toutes les transactions',
    moneyBackLabel: 'Remboursement Garanti',
    moneyBackDesc: 'Garantie de remboursement 30 jours',

    // Buttons & Actions
    addToCart: 'Ajouter au Panier',
    instantDelivery: 'Livraison Instantanée par Email',

    // Labels
    advancedFeatures: 'Fonctionnalités Avancées',
    professionalTools: 'Outils et ressources professionnels',
    unlimitedAccess: 'Accès illimité au contenu premium',
    dedicatedSupport: 'Support dédié 24/7',
    benefits: 'Avantages',
    saveTime: 'Économiser du temps et augmenter la productivité',
    itemsUnlocked: 'Tous les éléments débloqués et prêts à être utilisés',
    plansAvailable: 'Plans mensuels ou à vie disponibles',

    // Review Labels
    rating: 'Note',
    outOfStock_msg: 'Rupture de Stock',
    inStock_msg: 'En Stock',

    // Contact Info
    emailLabel: 'Email',
    whatsappLabel: 'WhatsApp',
    telegramLabel: 'Telegram',

    // Quantity
    quantity: 'Quantité',
    decrease: 'Diminuer',
    increase: 'Augmenter',

    // Price Info
    regularPrice: 'Prix Régulier',
    discountedPrice: 'Prix Réduit',
    save: 'Économisez',
    discount: 'Remise',

    // Monthly/Yearly text
    monthlyPlan: 'Plan Mensuel',
    yearlyPlan: 'Plan Annuel',

    // Support hours
    supportHours: '10 AM - 11 PM (PKT)',
  },
};

export const useProductDetailTranslations = (language = 'en') => {
  return productDetailTranslations[language] || productDetailTranslations['en'];
};
